@use '@itm/shared-frontend/lib/assets/styles/bulma/shared' as *;

.Wrapper {
  min-height: 100vh;
}

.Header {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  padding: 18px 3rem 17px;
}
.Main {
  position: relative;
  width: 433px;
  max-width: 100%;
  min-height: 100vh;
  margin: 0 auto;
  padding: 100px 64px 50px;
  @include mobile {
    width: 100%;
    padding: 100px 1rem 3rem;
  }
  &.Wide {
    width: 800px;
  }
  &.WithUserNav {
    padding: 18px 64px 50px;
    @include mobile {
      padding: 18px 1rem 3rem;
    }
  }
}

.Footer {
  margin: auto -10px 0 -10px;
  @include mobile {
    margin: 0;
  }
}
